import React from "react"
import {
  Box,
  Container,
  Grid,
  Heading,
  Text,
} from "@theme-ui/components"
import { GatsbyImage } from "gatsby-plugin-image"
import linkSwitch from "../../utils/linkSwitch"
import { i18nContext } from "../../context/i18nContext"
import { InboundLink } from "../link"
import { changeAriaboxFontToOrbitron } from "../../utils/fontChanger"

const ProductGridHome = ({ page, items }) => {
  return (
    <Box sx={{ py: [4, 4, 5, 5] }}>
      <Container>
        <Box sx={{ mb: [4, 4, 5] }}>
          <Text variant="caption">{page.label}</Text>
          <Heading
            as="div"
            variant="sectionTitle"
            sx={{
              fontSize: [6],
              fontWeight: "body",
              letterSpacing: "-.5px",
              lineHeight: "1.12",
              em: {
                fontStyle: "normal",
                color: "primary",
              },
            }}
            dangerouslySetInnerHTML={{ __html: page.title }}
          />
        </Box>

        <Grid
          columns={[1, 1, "1fr 1fr 1fr"]}
          gap={[4, 4, 4, 4]}
        >
          {items.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {/* Image */}
              <Box
                sx={{
                  width: "100%",
                  height: ["250px", "280px", "250px", "280px"],
                  overflow: "hidden",
                  mb: [3],
                }}
              >
                {item.image?.gatsbyImageData ? (
                  <GatsbyImage
                    image={item.image.gatsbyImageData}
                    alt={item.title || ""}
                    style={{ height: "100%", width: "100%" }}
                    imgStyle={{ objectFit: "cover" }}
                  />
                ) : (
                  item.image?.url && (
                    <img
                      src={item.image.url}
                      alt={item.title || ""}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  )
                )}
              </Box>

              {/* Title with yellow accent */}
              <Box sx={{ mb: [3] }}>
                <Heading
                  as="h3"
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    fontSize: [3, 3, 3, 4],
                    lineHeight: "1.3",
                    mb: [2],
                  }}
                >
                  {item.title}
                </Heading>
                <Box
                  sx={{
                    width: "48px",
                    height: "4px",
                    backgroundColor: "primary",
                    opacity: 0.8,
                  }}
                />
              </Box>

              {/* Description */}
              <Text
                as="div"
                variant="p"
                sx={{
                  mb: [4],
                  flex: 1,
                  fontSize: [1, 1, 1, 2],
                  lineHeight: "1.6",
                  color: "text",
                  p: {
                    m: 0,
                    mb: [2],
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: changeAriaboxFontToOrbitron(item.description),
                }}
              />

              {/* Button */}
              <i18nContext.Consumer>
                {t => (
                  <Box>
                    {linkSwitch(item.viewMore)?.href && (
                      <InboundLink
                        variant="buttons.full.primary"
                        sx={{
                          display: "inline-block",
                          fontWeight: "bold",
                          fontSize: [1, 1, 1, 2],
                          textDecoration: "none",
                        }}
                        to={linkSwitch(item.viewMore).href}
                      >
                        {t.goToProduct} +
                      </InboundLink>
                    )}
                  </Box>
                )}
              </i18nContext.Consumer>
            </Box>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default ProductGridHome
